module.exports = __webpack_public_path__ + "slide5-release.33192560599484233e50df03fbbf025f.hashedasset.svg";